export class NonmatchingObjectChecksum extends Error {
  constructor() {
    super(
      'The effects of this removal request have changed since they were last requested. ' +
        'Please review your request and resubmit it.',
    )
    Object.setPrototypeOf(this, NonmatchingObjectChecksum.prototype)
  }
}
